import { useEffect } from 'react';

import { type InfiniteData } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

// TODO: React Query implementation should be refactored and this removed

import { legacyConvertCurrency } from '@pkg/components/Sections/Groups/helpers';

import { DaasActivityFeedEventType, YacsTopicKey, YacsTopicTypes } from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';
import { type MutableGetGroupItemsResponse } from '@app/client/common/structs/groups/groups';
import { Currency } from '@app/client/common/structs/nft/currencies';
import { reactQueryClient } from '@app/reactQueryClient';

import { useGroupFilterParams } from './useGroupFilterParams';
import { groupsCacheKeys } from './utils';

export type FloorGameMessage = {
    slug: string;
    reservoirId: string;
    source: string;
    floorPriceWei?: string;
    eventDateString: string;
};

export const useFloorGameActivity = () => {
    const { groupId: groupIdParam } = useParams<{ groupId?: string }>();
    const filters = useGroupFilterParams();

    useEffect(() => {
        apiFactory().websocketConnections.yacs.connection?.emit(
            YacsTopicKey.subscribe,
            `${YacsTopicTypes.FloorPrice}.*`,
        );

        apiFactory().websocketConnections.yacs.connection?.on(DaasActivityFeedEventType.FloorPriceEvent, (...args) => {
            const message = args[0] as FloorGameMessage;
            const { slug, floorPriceWei } = message || {};
            const floorPriceEth = legacyConvertCurrency(parseFloat(floorPriceWei || '0'), Currency.WEI, Currency.ETH);

            reactQueryClient.setQueryData(
                groupsCacheKeys.items(groupIdParam, filters),
                (data: InfiniteData<MutableGetGroupItemsResponse> | undefined) => {
                    if (data && data?.pages?.[0]?.data.length) {
                        const pages = structuredClone(data.pages);

                        for (const page in pages) {
                            const pageClone = pages[page];
                            for (const itemKey in pageClone.data) {
                                const itemClone = pageClone.data[itemKey];

                                if (itemClone.item.item_type.Nft.slug === slug) {
                                    itemClone.item.item_type.Nft.floor_price = floorPriceEth;
                                    pageClone.data[itemKey] = itemClone;
                                }
                            }
                            pages[page] = pageClone;
                        }
                        return { ...data, pages };
                    }
                },
            );
        });

        return () => {
            apiFactory().websocketConnections.yacs.connection?.off(DaasActivityFeedEventType.FloorPriceEvent);

            apiFactory().websocketConnections.yacs.connection?.emit(
                YacsTopicKey.unsubscribe,
                `${YacsTopicTypes.FloorPrice}.*`,
            );
        };
    }, [groupIdParam, filters]);
};
